var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0883 7.79363H8.64715C8.03871 7.79363 7.45519 8.03533 7.02496 8.46556C6.59473 8.89579 6.35303 9.47931 6.35303 10.0877V20.4113C6.35303 21.0197 6.59473 21.6032 7.02496 22.0335C7.45519 22.4637 8.03871 22.7054 8.64715 22.7054H18.9707C19.5791 22.7054 20.1626 22.4637 20.5929 22.0335C21.0231 21.6032 21.2648 21.0197 21.2648 20.4113V16.9701M16.6766 8.94069C16.6766 9.85335 17.0391 10.7286 17.6845 11.374C18.3298 12.0193 19.2051 12.3819 20.1177 12.3819C21.0304 12.3819 21.9057 12.0193 22.551 11.374C23.1964 10.7286 23.5589 9.85335 23.5589 8.94069C23.5589 8.02803 23.1964 7.15275 22.551 6.50741C21.9057 5.86206 21.0304 5.49951 20.1177 5.49951C19.2051 5.49951 18.3298 5.86206 17.6845 6.50741C17.0391 7.15275 16.6766 8.02803 16.6766 8.94069Z",
    stroke: "#FF4242",
    strokeWidth: 2.29412,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.882a96f8ff969078d854bbfa84c18789.svg";
export { ForwardRef as ReactComponent };